module.exports = __webpack_public_path__ + "static/NavLogoGold-c4e8e50bcf5191df09a20b546152126b.png";